var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.27,8.08c-1.39,0-2.79,0-4.18,0-.67,0-1-.21-1-.92,0-1.32,0-2.64,0-4,0-.63.22-.92.88-.91h8.66c.61,0,.89.21.89.84q0,2.06,0,4.11c0,.63-.28.85-.89.84Zm0-1.16H9.4a.91.91,0,0,0,1-1c0-.51,0-1,0-1.52a.9.9,0,0,0-1-1c-2,0-4.09,0-6.13,0a1,1,0,0,0-1,1c0,.43,0,.86,0,1.3,0,.77.35,1.13,1.12,1.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.71,7c1,0,1.15.06,1.15,1,0,1.3,0,2.6,0,3.9,0,.66-.26.9-.91.89q-4.29,0-8.6,0c-.63,0-.94-.21-.92-.88,0-.84,0-1.68,0-2.55H4.61v1.17c0,.73.36,1.1,1.07,1.1h5.93a1,1,0,0,0,1.1-1.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.4,4a1.16,1.16,0,0,1-.11,2.31,1.18,1.18,0,0,1-1.1-1.21A1.17,1.17,0,0,1,6.4,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.52,9.25a1.15,1.15,0,0,0,2.29.06s0,0,0-.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.ba8405977b2bb700ffa9eac127fc90e0.svg";
export { ForwardRef as ReactComponent };